import { useContext } from "react";
import { createPortal } from "react-dom";
import { PanelActionsContext } from "./ClientConsolePanelShell";

/**
 * Renders a section's action buttons into the VS panel header instead of at
 * the top of its content.
 *
 * Wrap the buttons a section already had and pass `active` (normally the
 * section's `inPanel` prop). When the slot is not available — the Edit
 * branch's collapsible row, or the first render before the callback ref has
 * supplied the node — the children render exactly where they were written, so
 * the old surface is unaffected and nothing can disappear.
 *
 *   <PanelActions active={inPanel}>
 *     <BdrButton …>Add New Note</BdrButton>
 *   </PanelActions>
 */
const PanelActions = ({ active, children }) => {
  const slot = useContext(PanelActionsContext);
  if (!active || !slot) return children;
  return createPortal(children, slot);
};

export default PanelActions;
